import { isString } from "lodash";

export const isUUID = (value?: string | null): value is string => {
  if (!isString(value)) {
    return false;
  }

  // UUID regex pattern (supports all versions 1-5)
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  return uuidRegex.test(value);
};
